import React, { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { LiveVetForm } from '../../components/liveVet/liveVetForm/liveVetForm';
import { ConsultationScreen } from '../../components/liveVet/consultationScreen/consultationScreen';
import { FAQContent } from '../../components/liveVet/faqContent';
import { SESSION_STORAGE_KEYS } from '../../constants/sessionStorageKeys';
import { FAQ_CODENAME } from '../../constants/cmsCodeName';
import { FeatureFlagContext } from '../../contextProviders/featureFlagContext';
import { CSPUrlsMap } from '../../routes/CSPUrlsMap';
import './liveVet.scss';

export const LiveVet = () => {
  const [consultationUrl, setConsultationUrl] = useState(localStorage.getItem(SESSION_STORAGE_KEYS.LIVE_VET_SESSION));
  const { cspConfiguration } = useContext(FeatureFlagContext);
  const isLiveVetEnabled = cspConfiguration?.IsLiveVetEnabled || false;
  const navigate = useNavigate();

  const renderLiveVetContent = () => {
    if (!isLiveVetEnabled) {
      return (
        <div className="livevet-unavailable">
          <h2>24/7 Live Vet Service is unavailable.</h2>
          <span className="message">The service is currently unavailable please come back again later.</span>

          <button
            type="button"
            className="button outline"
            onClick={() => navigate(CSPUrlsMap.dashboard.url)}
          >
            Back to Dashboard
          </button>
        </div>
      );
    }
    if (consultationUrl) {
      return <ConsultationScreen consultationUrl={consultationUrl} />;
    }
    return <LiveVetForm setConsultationUrl={setConsultationUrl} />;
  };

  return (
    <div className="petSureForm liveVetForm">
      <div className="main-content">
        <h1 className="mainPageHeader">24/7 Live Vet support</h1>
        {renderLiveVetContent()}
      </div>
      {!consultationUrl && <FAQContent faqCategory={FAQ_CODENAME.LIVE_VET} />}
    </div>
  );
};
